module.exports = __webpack_public_path__ + "static/media/edit.5c262073.svg";